import Vue from 'vue'
import * as types from './types'
// import { formatTime } from '@/utils/utils';
export default {
  fetching(state, payload) {
		state.isFetching = payload
	},
	[types.SET_WECHAT_SHARE] (state, payload) {
    state.shareConfig = payload.shareObject
  },
  [types.SET_WECHAT_CONFIG] (state, payload) {
    state.jsConfig = JSON.parse(payload.jsConfig)
  },
  [types.PAY_SUCCESS]() {},
  [types.SET_TOKEN] (state,token) {
    state.token = token
    if(localStorage.getItem('token')){
      localStorage.removeItem('token')
    }
    localStorage.setItem('token', token)
  },
  [types.REMOVE_TOKEN] (state) {
    state.token = null
    localStorage.removeItem('token')
  },
  [types.SET_COMPANY_LOWCASE] (state, payload) {
    state.companyUrl = payload.companyUrl
  }
}